import { Language } from 'Services/Api/Languages/Types';

export const languageNames = (
	ids: number[] | undefined,
	languagesById: Record<number, Language>
): string[] =>
	Array.from(new Set(ids ?? []))
		.map((id) => languagesById[id]?.name)
		.filter((name): name is string => Boolean(name));
